<template>
  <the-mask
    :value="value"
    :mask="['### ### ###', '### ### ####']"
    class="form-control"
    @blur.native="blur"
    :disabled="disabled"
    type="tel"
    :placeholder="placeholder"
    @input="input"
  />
</template>

<script>
import { TheMask } from "vue-the-mask";

export default {
  components: {
    TheMask,
  },
  props: {
    placeholder: {},
    name: {},
    disabled: {},
    value: {},
    prefix: {},
    errors: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      money: {
        decimal: ".",
        thousands: ",",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false,
      },
    };
  },
  methods: {
    input(value) {
      this.$emit("input", value);
      this.$emit("change", value);
    },
    blur() {
      this.$emit("blur");
    },
  },
};
</script>

<style scoped>
</style>
